export default {
      id: "icon-1-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-1",
      toString: function () {
        return this.url;
      }
    }